import { AEntity } from "../a-entity";
import { IMenuStructure } from "./i-menu-structure";

export class Right extends AEntity implements IMenuStructure {
    code: string;
    translation: string;
    rank: number;

    menuId: number;
    rightId: number;

    structurePath: string;
    isOwned: boolean;
    restrictionExplanation: string;

    private _subRights: Right[];
    get subRights(): Right[] {
        return this._subRights;
    }
    set subRights(subRights: Right[]) {
        this._subRights = this.convertArray(Right, subRights).sort((a, b): number => {
            if (a.rank < b.rank) return -1;
            else if (a.rank > b.rank) return 1;
            else if (a.code < b.code) return -1;
            else if (a.code > b.code) return 1;
            else return 0;
        });
    }

    private compareFn = (a: IMenuStructure, b: IMenuStructure) => { return (a.rank < b.rank) ? -1 : ((a.rank > b.rank) ? 1 : 0); };
    get children(): IMenuStructure[] { return this.subRights.sort(this.compareFn); }
}
